import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'

const FooterMainMenuContentBlock = ({ placeholders: { footerMainContentBlocks = []} = {}, ...props }) =>
  <Wrapper>
    <InnerWrapper data-max-width role="navigation" aria-label="Secondary">
      { footerMainContentBlocks }
    </InnerWrapper>
  </Wrapper>

FooterMainMenuContentBlock.propTypes = {
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    footerContents: PropTypes.arrayOf(PropTypes.shape())
  })
}

export default FooterMainMenuContentBlock

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: ${Theme.colors.black_new};
  background-size: cover;
  ${Mixin.responsive('padding', '0 50px', '16px 16px 0')}
`
const InnerWrapper = styled.div`
  display: table;
  width: 100%;
`
